<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        bottom: -100px !important;
        opacity: 0 !important;
    }

</style>

<template>
    <transition name="fade">
        <div v-if="snack_bar_show"
             :class="getTypeClass"
             class="flex items-center absolute bottom-0 left-0 right-0 mx-auto z-50
            w-full md:w-1/4
            mb-0 md:mb-2
            md:rounded
            bg-black"
        >
            <div v-if="message" class="py-1 text-xs text-center w-full">{{message}}</div>
            <div class="h-full border-l border-gray-800 p-1" @click="snack_bar_close">
                <unicon name="times"></unicon>
            </div>
        </div>
    </transition>
</template>
<script>
    import {mapGetters, mapMutations, mapState} from 'vuex'

    export default {
        name: 'SnackBar',
        computed: {
            ...mapState('snack_bar', ['type']),
            ...mapGetters('snack_bar', [
                'message', 'snack_bar_show'
            ]),
            getTypeClass() {
                let res = ' text-gray-600';

                if (this.type === 'error') {
                    res += ' text-danger-200'
                }
                if (this.type === 'success') {
                    res += ' text-success'
                }
                if (this.type === 'warning') {
                    res += ' text-warning'
                }
                console.log(res);
                return res;
            }
        },
        methods: {
            ...mapMutations('snack_bar', [
                'snack_bar_close'
            ]),
        },
    }
</script>